// extracted by mini-css-extract-plugin
module.exports = {"container":"LegendPower_container__19dmF","h2Laptop":"LegendPower_h2Laptop__3WXtf","h2Mobile":"LegendPower_h2Mobile__3zZmI"};